import { useDispatch } from 'react-redux';
import {
  API_ROOT_URL,
  CREATE_RENDER,
  DOWNLOAD_RENDER_IMAGE,
} from '../../../config/constant/apiConstant';
import { AUTH_TOKEN, REFRESH_TOKEN } from '../../../config/constant/projectConstant';
// import { CUSTOMIZE_EXPERIENCE, Customize_Experience, TERMS_CONDITION_ROUTE } from '../../../config/constant/routePathConstant';
import api from '../../../helpers/axiosHelper';
import { getLocalStorage, openFormInCaseOfNewOrgAndFreemiumUser, setLocalStorage } from '../../../helpers/jsHelper';
import { errorToast } from '../../../helpers/toastHelper';
import { saveAs } from 'file-saver';
import { apiGetPreviewAndMainRenders, GET_RENDER_PREVIEW_DATA } from '../../../helpers/api';
import { imagePaymentFormPopupActions } from '../../../redux/slicers/imagePaymentFormPopupSlicer';
import { dispatcher } from '../../../helpers/projectHelper';
import { RP_STATUS } from '../../../constants/renderPreviewConstants';
import { createNsetClientSecretKey } from '../../../components/admin/curator/RenderPreviewsDialog/PaymentFormForImages';
import { LogCurator } from '../../../helpers/logEvents';
// import { navigate } from '../../../helpers/projectHelper';
// import { successToast } from '../../../helpers/toastHelper';
// import {setSearchValue, setSearchResult} from "../../../redux/slicers/search/searchSlicer";

export const createRenderAPI = async (
  formData,
  { onSuccess, onError, afterAll, renderId , showError = true, hideNewPlans = false , isFreemiumUser = false} = {}
) => {
  // console.log(search);
  let mainRenderId = null;
  if (!renderId) {
    const result = await api()
      .root(API_ROOT_URL)
      .post(CREATE_RENDER)
      .data(formData)
      .success((data) => {
        setLocalStorage('renderStatus', data.status);
        // onSuccess?.(data?.data)
      })
      .error((error) => {
        // dispatch(setSearchResult(error))
        console.log('create render api error: ', error);

        console.log('error.status : ', error.status);

        setLocalStorage('renderStatus', error.status);

        // if(error.status === null || error.status === undefined){
        //     errorToast(`Unable to create Render/Preview.`)
        // }

        onError?.();
      })
      // .finally(() => {
      //     afterAll?.();
      // })
      .send();
    mainRenderId = result?.data?.id;
    if (!mainRenderId) {
      // errorToast(`Someting went wrong while creating Render/Preview.`)
      afterAll?.();
      return;
    }
    if (result?.data?.status === RP_STATUS.STATUS_DISABLED) {
      dispatcher(imagePaymentFormPopupActions.setDisabledRenderJobId(mainRenderId));
      await createNsetClientSecretKey();
      // Task to show the enterprise form and not the payment form DEV-35824
      if (hideNewPlans || isFreemiumUser) {
        openFormInCaseOfNewOrgAndFreemiumUser();
      } else {
        dispatcher(imagePaymentFormPopupActions.show());
      }
      afterAll?.();
      return;
    }
  }

  return api()
    .root(API_ROOT_URL)
    .get(`${GET_RENDER_PREVIEW_DATA}?sort=-created_at&main_render=${renderId || mainRenderId}`)
    .success((data) => {
      const render = data.results[0];
      if (!render) {
        throw Error('Unable to process your image');
      }
      onSuccess(render);
    })
    .error((error) => {
      console.log('get render api error: ', error);
      if(showError) {
        errorToast(`Unable to process your image`);
      }
      onError?.();
    })
    .finally(() => {
      afterAll?.();
    })
    .send();
};

export const downloadRenderAPI = (id) => {
  // const headers = { 'Content-Type': 'application/zip' }
  const headers = {
    // 'Accept': 'application/zip',
    // 'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/zip',
  };

  //     api().root(API_ROOT_URL).post(CREATE_CAMERA_ANGLE).data(formData).setHeaders(headers).success((data)=>{

  api()
    .root(API_ROOT_URL)
    .get(`${DOWNLOAD_RENDER_IMAGE}?ids=${id}`)
    .setHeaders(headers)
    .success((data) => {
      // dispatch(setSearchResult(data))

      // const data = d

      // var blob = new Blob([data], {type: "Content-Type"});
      // var blob = new Blob([data]);
      // var blob = new Blob([data], {type: "application/zip, application/octet-stream"});
      // var blob = new Blob([data], {type: "application/octet-stream"});
      // var blob = new Blob([data], {type: "octet/stream"});

      // console.log("download render api success: ", data)
      // console.log("download render api success length: ", data.length)
      // console.log("download render api success blob.size: ", blob.size)
      // console.log("download render api success string: ", data.toString())

      // const url = URL.createObjectURL(blob);
      //   saveAs(data, "file.zip");
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute(
      //     'download',
      //     'FileName.zip',
      //   );

      //   document.body.appendChild(link);

      //   link.click();

      //   link.parentNode.removeChild(link);

      const blob = new Blob([data], { type: 'application/zip' });
      LogCurator('download render blob: ', blob);

      LogCurator('download blob url:', URL.createObjectURL(blob));
      // saveAs(URL.createObjectURL(blob), "file.zip");

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'file.zip'); //set download attribute to link
      document.body.appendChild(link);
      link.click();

      // var reader = new FileReader();
      // reader.onload = function() {
      //   console.log(JSON.parse(this.result));

      //   window.location(JSON.parse(this.result))
      // };
      // reader.readAsText(blob);
    })
    .error((error) => {
      // dispatch(setSearchResult(error))
      LogCurator('download render api error: ', error);
    })
    .send();
};
